import { ReactNode } from 'react'
type SectionProps = {
    active: boolean
    children: ReactNode
}
export const BasicDetails = ({ active, children }: SectionProps) => (
    <div style={{ display: active ? 'block' : 'none' }}>{children}</div>
)
export const FilteringOptions = ({ active, children }: SectionProps) => (
    <div style={{ display: active ? 'block' : 'none' }}>{children}</div>
)